import React, { useState } from "react";
import styled from "styled-components";
import { MdAlternateEmail } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { HiOutlineMailOpen } from "react-icons/hi";
import { AiFillGithub, AiFillLinkedin, AiOutlineArrowUp } from "react-icons/ai";
import { BsSlack } from "react-icons/bs";
import { FiMail, FiPhoneCall } from "react-icons/fi";
import { Slide, Zoom, Fade } from "react-awesome-reveal";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const Footer = () => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const scrollUp = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  const form = useRef();
  /*
  const sendForm = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_id', 'template_id', form.current, '000-1-ABcdEFGH-2s')
      .then((result) => {
          console.log(result.text);
          console.log("message sent", result)
      }, (error) => {
          console.log(error.text);
      });
  };

*/

  const sendForm = (event) => {
    event.preventDefault();
    setLoading(true);

    const form = event.target;
    // const user = form.querySelector('[name="user"]');
    // const message = form.querySelector('[name="message"]');

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form,
        process.env.REACT_APP_USER_ID,
      )
      .then((response) => {
        console.log("Email sent:", response);
        setSuccess(true);
        setLoading(false);
      })
      .catch((error) => {
        setSuccess(false);
        console.error("Error sending email:", error);
        setLoading(false);
      });
  };

  return (
    <Container id="footer">
      <Profile>
        <Slide direction="left" delay={1}>
          <h1>Portfolio</h1>
        </Slide>
        <div className="address">
          <Slide direction="left">
            <h1>Address:</h1>
          </Slide>
          <Slide direction="left">
            <p>Lahore Punjab, Pakistan(PK), 05426</p>
          </Slide>
        </div>
        <div className="links">
          <Slide direction="left">
            <h1>Contact me directly:</h1>
          </Slide>
          <div>
            <span>
              <FiPhoneCall />
            </span>
            <Slide direction="left">
              <a href={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}>
                +92 304 550 9363
              </a>
            </Slide>
          </div>
          <div>
            <Slide direction="left">
              <span>
                <HiOutlineMailOpen />
              </span>
            </Slide>
            <Slide>
              <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>
                {process.env.REACT_APP_EMAIL}
              </a>
              {/* <a href="mailto:usamabajwa3030@gmail.com">
                usamabajwa3030@gmail.com
              </a> */}
            </Slide>
          </div>
        </div>
        <div className="profiles">
          <Slide direction="left">
            <h1>Check my profiles</h1>
          </Slide>
          <div className="icons">
            <Zoom>
              <span>
                <a href={process.env.REACT_APP_GITHUB_URL} target="blank">
                  <AiFillGithub />
                </a>
              </span>
            </Zoom>
            <Zoom>
              <span>
                <a href={process.env.REACT_APP_LINKEDIN_URL} target="blank">
                  <AiFillLinkedin />
                </a>
              </span>
            </Zoom>
            {/* <Zoom>
              <span>
                <a href="/">
                  <BsFacebook />
                </a>
              </span>
            </Zoom> */}
            <Zoom>
              <span>
                <a href={process.env.REACT_APP_SLACK_URL} target="blank">
                  <BsSlack />
                </a>
              </span>
            </Zoom>
          </div>
        </div>
        <Fade>
          <ArrowUp onClick={scrollUp}>
            <AiOutlineArrowUp />
          </ArrowUp>
        </Fade>
      </Profile>
      {success ? (
        <Sucess>
          <Zoom>
            <h1>
              Thank you for your <span className="green">message</span>
            </h1>
            <p>
              Looking forward to receiving your email and discussing the details
              with you.
            </p>
          </Zoom>
        </Sucess>
      ) : (
        <Form>
          <Slide direction="right">
            <form ref={form} onSubmit={sendForm}>
              <div className="name">
                <span>
                  <CgProfile />
                </span>
                <input type="text" name="user_name" placeholder="Fullname..." />
              </div>
              <div className="email">
                <span>
                  <MdAlternateEmail />
                </span>
                <input type="email" name="user_email" placeholder="Email..." />
              </div>
              <div className="message">
                <span className="messageIcon">
                  <FiMail />
                </span>
                <textarea
                  cols="30"
                  rows="10"
                  name="message"
                  placeholder="Message..."
                ></textarea>
              </div>
              <button type="submit" disabled={loading}>
                {loading ? "Loading..." : "Submit"}
              </button>
            </form>
          </Slide>
        </Form>
      )}
    </Container>
  );
};

export default Footer;

const Container = styled.div`
  margin-top: 2rem;
  position: relative;
  padding: 2rem 0;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  @media (max-width: 840px) {
    width: 90%;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    gap: 3rem;
  }
`;
const Profile = styled.div`
  flex: 1;
  .address {
    padding: 1rem 0;
    h1 {
      font-size: 1.2rem;
    }

    p {
      width: 60%;
      padding-top: 0.5rem;
      @media (max-width: 650px) {
        width: 100%;
      }
    }
  }

  .links {
    h1 {
      font-size: 1.2rem;
      margin-bottom: 0.5rem;
    }

    div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      a {
        text-decoration: none;
        color: lightgray;
        :hover {
          color: orange;
        }
      }
    }
  }

  .profiles {
    h1 {
      font-size: 1.2rem;
      padding: 1rem 0;
    }

    .icons {
      display: flex;
      align-items: center;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;
        width: 2rem;
        height: 2rem;
        margin-right: 0.5rem;
        border-radius: 50px;

        :hover {
          background-color: orange;
        }

        a {
          margin-top: 0.2rem;
          color: #fff;
        }
      }
    }
  }
`;
const ArrowUp = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: #01be96;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 700;
  margin-top: 2rem;
  @media (max-width: 650px) {
    position: absolute;
    right: 3rem;
    top: 16rem;
  }
`;
const Form = styled.div`
  flex: 1;
  h1 {
    font-size: 1.3rem;
    padding-bottom: 0.7rem;
  }

  form {
    background-color: #191923;
    padding: 0.8rem;
    border-radius: 5px;
    .name,
    .email,
    .message {
      display: flex;
      border: 1px solid gray;
      margin-bottom: 0.5rem;
      input,
      textarea {
        width: 100%;
        border: none;
        outline: none;
        color: #fff;
        background-color: transparent;
        padding: 1rem 0.5rem;
      }
      span {
        background-color: #3e3e3e;
        width: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .messageIcon {
        align-items: flex-start;
        padding-top: 0.5rem;
      }
    }

    button {
      width: 5rem;
      height: 1.8rem;
      background-color: #01be96;
      border: none;
      border-radius: 5px;
      filter: drop-shadow(0px 4px 5px #01be9551);
      cursor: pointer;
      :hover {
        filter: drop-shadow(0px 6px 9px #01be9551);
      }
    }
  }
`;

const Sucess = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 1.4rem;
    padding-bottom: 0.7rem;
    margin-bottom: auto; /* Aligns h1 to the top */
  }

  p {
    text-align: center;
    align-self: center;
    margin-top: 2rem; /* Adjust as needed */
    margin-bottom: auto; /* Aligns p to the center */
  }
`;
